module.exports = __webpack_public_path__ + "static/team-small-b9d4b19937d6f62c83e79ca4be67f8d9.jpg";